import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import { companyInfo } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy-primary text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_premium-site-care/artifacts/9ehk0y5k_IMG_2385.png" 
              alt="Illyria Landscape Management" 
              className="h-16 w-auto mb-6"
            />
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-ice-blue/80 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-ice-blue/80 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-ice-blue/80 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-ice-blue/80 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-ice-blue" />
                <a href={`tel:${companyInfo.phone}`} className="text-ice-blue/80 hover:text-white transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} className="text-ice-blue" />
                <a href={`mailto:${companyInfo.email}`} className="text-ice-blue/80 hover:text-white transition-colors">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Service Area */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Service Area</h4>
            <p className="text-ice-blue/80">
              Toronto & the Greater Toronto Area (GTA)
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-ice-blue/20 mt-12 pt-8">
          <p className="text-ice-blue/60 text-sm text-center">
            © {currentYear} Illyria Landscape Management. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

